import { render } from "./StandardForm.vue?vue&type=template&id=75ea9bc2"
import script from "./StandardForm.vue?vue&type=script&lang=js"
export * from "./StandardForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__